import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { initGuard } from './init.guard';
import { authGuard } from './auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'user',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: (): Promise<any> => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [initGuard]
  },
  {
    path: 'user',
    loadChildren: (): Promise<any> => import('./tabs/privateTabs.module').then(m => m.PrivateTabsModule),
    canActivate: [initGuard, authGuard]
  },
  {
    // workaround to erroneous path from reset email #15
    path: 'reset/:resetCode',
    redirectTo: 'auth/reset-password/:resetCode',
    pathMatch: 'full'
  },
  {
    // used for signatures with eSignAnyWhere
    path: 'redirect/firmaSuccess',
    redirectTo: 'user/estimates/from-esignanywhere/checkout',
    pathMatch: 'full'
  },
  {
    // used for signatures with eSignAnyWhere
    path: 'redirect/firmaFailure',
    redirectTo: 'user/estimates/from-esignanywhere/checkout',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
